import { useMemo } from 'react';

import type { TTheme, TThemeShade } from '@feathr/components';
import { themeToHex } from '@feathr/components';

interface ILimitColorFeedback {
  progressTheme: TTheme;
  wellTheme: TTheme;
  progressShade: TThemeShade;
  progressColor: string;
  wellColor: string;
  summaryColor: string;
}

export function useLimitColorFeedback(used: number, limit: number): ILimitColorFeedback {
  return useMemo(() => {
    const usagePercentage = limit > 0 ? Math.floor((used / limit) * 100) : 0;

    let wellTheme: TTheme = 'neutral';
    const wellShade: TThemeShade = 500;
    let progressTheme: TTheme = 'neutral';
    let progressShade: TThemeShade = 900;
    let summaryColor = 'var(--color-text-heading)';

    if (usagePercentage >= 90) {
      progressTheme = 'red';
      wellTheme = 'red';
      progressShade = 600;
      summaryColor = 'var(--color-red-700)';
    } else if (usagePercentage >= 75) {
      progressTheme = 'yellow';
      progressShade = 600;
      summaryColor = 'var(--color-yellow-700)';
    }

    const progressColor = themeToHex(progressTheme, progressShade);
    const wellColor = themeToHex(wellTheme, wellShade);

    return { progressTheme, wellTheme, progressShade, progressColor, wellColor, summaryColor };
  }, [used, limit]);
}
